import { render, staticRenderFns } from "./hdjetj.vue?vue&type=template&id=2cc971db&scoped=true&"
import script from "./hdjetj.vue?vue&type=script&lang=js&"
export * from "./hdjetj.vue?vue&type=script&lang=js&"
import style0 from "./hdjetj.vue?vue&type=style&index=0&id=2cc971db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc971db",
  null
  
)

export default component.exports